import { render, staticRenderFns } from "./FormiumReplyViewer.vue?vue&type=template&id=5f612756"
import script from "./FormiumReplyViewer.vue?vue&type=script&lang=js"
export * from "./FormiumReplyViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports